.reviews-container{margin-top:20px}.main-primary-card-container{margin-right:30px}
/*# sourceMappingURL=client-reviews.component-OX4H7GIB.css.map */
